import axios from 'axios'
import { API_BASE, getHeaders } from './helpers'

const api = axios.create({ baseURL: API_BASE })
api.interceptors.request.use(config => {
  config.headers = getHeaders()
  return config
})

export const API = {
  post: (endpoint, data) => api.post(endpoint, data),
  put: (endpoint, data) => api.put(endpoint, data),
  get: (endpoint, params = {}) => api.get(endpoint, { params }),
  delete: endpoint => api.get(endpoint),
}
